import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { ConvenienceFee } from './ConvenienceFee'
import { Subscription } from './Subscription'

const CardBalance = types.model('CardBalance', {
  balance: types.optional(types.string, ''),
  isLoading: types.optional(types.boolean, false),
  error: types.optional(types.string, ''),
})
const Card = types.model('Card', {
  number: types.string,
  id: types.optional(types.number, 0),
  nickname: types.optional(types.string, ''),
  type: types.enumeration('CardTypes', ['DEBITCARD', 'CREDITCARD', 'FOODCARD']),
  subType: types.optional(types.string, ''),
  ownerName: types.optional(types.string, ''),
  issuer: types.optional(types.string, ''),
  issuerLogo: types.optional(types.string, ''),
  cvv: types.optional(types.string, ''),
  isCvvLess: types.optional(types.boolean, false),
  expyr: types.optional(types.number, 0),
  expmon: types.optional(types.number, 0),
  expDate: types.optional(types.string, ''),
  token: types.optional(types.string, ''),
  scheme: types.optional(types.string, ''),
  isSave: types.optional(types.boolean, false),
  emiBankId: types.optional(types.string, ''),
  isEMIEligible: types.optional(types.boolean, false),
  offerEligibility: types.optional(types.string, ''),
  isSubscription: types.optional(types.boolean, false),
  subscription: types.optional(Subscription, {}),
  convenienceFee: types.array(ConvenienceFee),
  cardBalance: types.optional(CardBalance, {}),
  paymentType: types.optional(types.string, 'Card'),
  product: types.optional(types.string, ''),
  isDomestic: types.optional(types.boolean, true),
})

// {
// 	"type": 140, // use type
// 	"name": "Rahul.K",//use ownerName
// 	"nickName": "Test",// use nickname
// 	"bankId": "4000", //use id
// 	"remark": "Food card", // use subType
// 	"vaultId": "198271", // use token
// 	"maskedNumber": "XXXXXXXXXXXX5905",// use number
// 	"product": "F",
// 	"isDomestic": true,
// 	"isPremium": false
// }

const CardTypes = {
  CREDITCARD: 'CREDITCARD',
  DEBITCARD: 'DEBITCARD',
  FOODCARD: 'FOODCARD',
}

export type CardType = Instance<typeof Card>
export { Card, CardTypes }
